import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, DataGrid, Grid, IconButton, IGridColDef, Stack, TextField } from 'src/components';
import {
    useHastalikTanimIslemAdetGuncelleMutation,
  useHastalikTanimIslemIptalMutation,
  useLazyHastalikTanimIslemGetirQuery
} from 'src/services/HastalikTanim/HastalikTanimApi';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch, useAppSelector } from 'src/store';

import VwHbsHastaliktanimislemDTO from 'src/models/HastalikTanim/VwHbsHastaliktanimislemDTO';
import HastalikTanimSlice from 'src/store/Slices/GenelTanimlar/HastalikTanimSlice';
import HastalikDialog from './HastalikDialog';
import api from 'src/services/core/api';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';
import { helper } from 'src/utils/helper';

interface IHastalikTaniIslemProps {}
const path = 'pages|hataliktanim';
const HastalikTaniIslem = (props: IHastalikTaniIslemProps): JSX.Element => {
  const hastalikTanimtaniAcitveRow = useAppSelector((s) => s.hastalikTanim.hastalikTanimtaniAcitveRow);
  const dialogParam = useAppSelector((s) => s.hastalikTanim.dialogParam);
  const fetchParam = useAppSelector((s) => s.hastalikTanim.fetchParam);

  const [adetGuncelle, adetGuncelleSate] = useHastalikTanimIslemAdetGuncelleMutation();
  const [iptal, iptalState] = useHastalikTanimIslemIptalMutation();

  const confirm = useConfirmation();
  const dispatch = useAppDispatch();

  const [query, queryState] = useLazyHastalikTanimIslemGetirQuery();

  const columns: IGridColDef<VwHbsHastaliktanimislemDTO>[] = [
    {
      field: 'icdaralik',
      headerName: translate(path, 'ICD Aralık'),
      minWidth: 100,
      flex: 1
    },
    {
      field: 'islemadi',
      headerName: translate(path, 'İşlem Adı'),
      minWidth: 100,
      flex: 1
    },
    {
      field: 'islemkodu',
      headerName: translate(path, 'İşlem Kodu'),
      minWidth: 100,
      flex: 1
    },
    {
      field: 'adet',
      headerName: translate(path, 'Adet'),
      width: 60,
      renderCell: (params) => {
        return (
          <Grid container>
            <Grid item md={5} sx={{alignContent:"center"}}>
              {params.row.adet}
            </Grid>
            <Grid item md={7}>
              <IconButton 
                customType="edit" 
                onClick={() => adetGuncelleHandler(params.row)}
               />
            </Grid>
          </Grid>

        );
      }
    },
    {
      field: 'action',
      headerName: '',
      width: 40,
      renderCell: (params) => {
        return (
          <>
            <IconButton customType="delete" onClick={() => iptalHandler(params.row)} loading={iptalState.isLoading} />
          </>
        );
      }
    }
  ];

  const columheaderHandler = () => {
    return (
      <Stack direction={'row'}>
        <Button customType="add" onClick={() => dispatch(HastalikTanimSlice.actions.setDialogParam(3))} />
      </Stack>
    );
  };

  const hastalikTanimTaniIslemGetirHandler = () => {
    query({ hastaliktanimTaniId: hastalikTanimtaniAcitveRow.id });
  };

  const adetGuncelleHandler = (row: VwHbsHastaliktanimislemDTO) => {
    let adet = row.adet
    confirm({
        description: <>
            <TextField 
                label={translate(path, "Adet Giriniz")}
                onChange = {(e) => adet = helper.objectToNumber(e.target.value)}
            />
        </>,
        catchOnCancel: true,
        title: row.adet.toString(),
        variant: 'danger'
      }).then(() => {
        adetGuncelle({
          id: row.id,
          adet: adet
        })
          .unwrap()
          .then(hastalikTanimTaniIslemGetirHandler);
      });
  }

  const iptalHandler = (row: VwHbsHastaliktanimislemDTO) => {
    confirm({
      description: translate(path, 'İşlem İptal Edilecektir. Emin Misiniz?'),
      catchOnCancel: true,
      title: '',
      variant: 'danger'
    }).then(() => {
      iptal({
        id: row.id
      })
        .unwrap()
        .then(hastalikTanimTaniIslemGetirHandler);
    });
  };

  useEffect(() => {
    if (hastalikTanimtaniAcitveRow.id) {
      hastalikTanimTaniIslemGetirHandler();
    }
  }, [hastalikTanimtaniAcitveRow]);

  useEffect(() => {
    if (fetchParam === 3) {
      hastalikTanimTaniIslemGetirHandler();
      dispatch(HastalikTanimSlice.actions.setFetchParam(0));
    }
  }, [fetchParam]);

  return (
    <>
      <DataGrid
        addHeaderColumn={columheaderHandler()}
        columns={columns}
        rows={queryState.data ? queryState.data : []}
        sx={{ height: '85vh' }}
        loading={queryState.isFetching}
        enableQuickFilter
      />
      {dialogParam === 3 && <HastalikDialog />}
    </>
  );
};

export default HastalikTaniIslem;
